import { SHOP_MENU_CACHE_TIME } from '../constants';
import getIsFetchingMenu from '../selectors/getIsFetchingMenu';
import getMenuFetchedDate from '../selectors/getMenuFetchedDate';

import fetchExtendedMenu from './fetchExtendedMenu';
import fetchShelvesMenu from './fetchShelvesMenu';
import getIsShelvesMenuLayout from '../selectors/getIsShelvesMenuLayout';

const cachedMenuExpired = date =>
  !date || Date.now() > date.getTime() + SHOP_MENU_CACHE_TIME;

const fetchMenu = ({
  shop,
  isScrolling = false,
  forceFetch = false,
  isPickup,
}) => (dispatch, getState) => {
  const state = getState();
  const date = getMenuFetchedDate(state);
  const isFetchingMenu = getIsFetchingMenu(state);
  const isShelvesMenuLayout = getIsShelvesMenuLayout(state);

  if (
    shop &&
    !isFetchingMenu &&
    (forceFetch || isScrolling || cachedMenuExpired(date))
  ) {
    return isShelvesMenuLayout
      ? dispatch(fetchShelvesMenu({ shop }))
      : dispatch(fetchExtendedMenu({ shop, isPickup }));
  }
  return null;
};

export default fetchMenu;
